import "./PlainTable.scss";
import { IconSvg } from "../../../utils/constants/icons/iconSvg.constant";

export const PlainTable = ({ data, actionHandler }) => {
  const getActionIcon = (name) => {
    const icons = {
      trash: <IconSvg tag="newTrash" />
    };

    return icons[name];
  };

  return (
    <div className="plain-table">
      <table className="plain-table__table">
        <thead>
        <tr className="plain-table__head-row">
          <th className="plain-table__head-cell plain-table__head-cell--first">IP</th>
          <th className="plain-table__head-cell plain-table__head-cell--second">List name</th>
          <th className="plain-table__head-cell plain-table__head-cell--actions"></th>
        </tr>
        </thead>
        <tbody>
        {data.map((item, index) => (
          <tr key={index} className={`plain-table__row ${item.selected ? "plain-table__row--selected" : ""}`}>
            <td className="plain-table__cell plain-table__cell--first">{item.ip}</td>
            <td className="plain-table__cell plain-table__cell--second">{item.listName || "—"}</td>
            <td className="plain-table__cell plain-table__cell--actions">
              {item.action && (
                <div className="plain-table__actions" onClick={actionHandler}>{getActionIcon(item.action)}</div>
              )}
            </td>
          </tr>
        ))}
        </tbody>
      </table>
    </div>
  );
};
